import React from "react";
import { MessageBoxSuccess as WebMessageBox } from "../WebStyles";
import { MessageBoxSuccess as WindowsMessageBox } from "../WindowsStyles";
import { MessageBoxSuccess as MacMessageBox } from "../MacStyles";
import { MessageBoxSuccess as LinuxMessageBox } from "../LinuxStyles";
import { MessageBoxSuccess as IosMessageBox } from "../iOSStyles";
import { MessageBoxSuccess as AndroidMessageBox } from "../AndroidStyles";
import { DEVICE_OS } from "@pcloud/web-utilities/dist/config/constants";

const MessageBoxSuccess = ({ os, ...rest}) => {
  switch (os) {
    case DEVICE_OS.Android:
      return <AndroidMessageBox {...rest}/>
    case DEVICE_OS.iOS:
      return <IosMessageBox {...rest}/>
    case DEVICE_OS.Web:
      return <WebMessageBox {...rest}/>
    case DEVICE_OS.Win:
      return <WindowsMessageBox {...rest}/>
    case DEVICE_OS.MacOSX:
      return <MacMessageBox {...rest}/>
    case DEVICE_OS.Linux:
      return <LinuxMessageBox {...rest}/>
    default:
      return <WebMessageBox {...rest}/>
  }
};

export default MessageBoxSuccess;
